const passwordRegex = /^[A-z0-9!#$%&()*+-.,/:;<>?@[\]^_`{|}~=]+$/;

const hasInvalidSymbols = (value: string) => {
  return !passwordRegex.test(value);
};

export default hasInvalidSymbols;
